<template>
  <!-- окно «Заявка на лизинг» / «Расчёт по вашему КП» — общая форма заявки -->
  <ui-modal medium :close="close">
    <div class="modal-header app-modal__head">
      <h5 class="modal-title">{{ title }}</h5>
      <button class="btn-close" type="button" @click="close"></button>
    </div>
    <div class="modal-body app-modal__body">
      <ApplicationForm
        :kind="kind"
        :limit="limit"
        :use-limit="useLimit"
        :initial="initial"
        :calc="calc"
        cancelable
        @cancel="close"
      />
    </div>
  </ui-modal>
</template>

<script>
import ApplicationForm from "./ApplicationForm.vue";

export default {
  name: "ApplicationModal",
  components: { ApplicationForm },
  props: {
    // own — своя техника, kp — расчёт по КП поставщика
    kind: { type: String, default: "own" },
    // одобренный лимит клиента, ₽ (0 — без выбора лимита)
    limit: { type: Number, default: 0 },
    // открыто из «Воспользоваться лимитом» — лимит выбран сразу
    useLimit: Boolean,
    // предзаполнение формы (позиция каталога — fromCatalogItem)
    initial: { type: Object, default: () => ({}) },
    // результат быстрого расчёта { payment, total }
    calc: { type: Object, default: null },
  },
  emits: ["close"],
  computed: {
    title() {
      return this.kind === "kp" ? "Расчёт по вашему КП" : "Заявка на лизинг";
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
